export const SHIPMENT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  READY_FOR_SHIPMENT: 'ready-for-shipment',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const

/** 出貨單狀態 */
export const SHIPMENT_STATUS_MAP = {
  [SHIPMENT_STATUS.PENDING]: '待付款',
  [SHIPMENT_STATUS.PROCESSING]: '處理中',
  [SHIPMENT_STATUS.READY_FOR_SHIPMENT]: '揀貨中',
  [SHIPMENT_STATUS.COMPLETED]: '完成訂單',
  [SHIPMENT_STATUS.CANCELLED]: '已取消',
} as const
